import {metadaApi} from '@dms/api/base';
import {BaseVoidResponseSchema} from '@dms/api/shared';

import {
  PostSalesServiceOrderVariantSetAsActiveApiArg,
  PostSalesServiceOrderVariantSetAsActiveApiArgSchema,
  PostSalesServiceOrderVariantSetAsActiveApiResponse,
  PostSalesServiceOrderVariantSetAsDefaultApiArg,
  PostSalesServiceOrderVariantSetAsDefaultApiArgSchema,
  PostSalesServiceOrderVariantSetAsDefaultApiResponse,
  PostSalesServiceOrderVariantSetAsInactiveApiArg,
  PostSalesServiceOrderVariantSetAsInactiveApiArgSchema,
  PostSalesServiceOrderVariantSetAsInactiveApiResponse,
  PostSalesServiceOrderVariantUnsetAsDefaultApiArg,
  PostSalesServiceOrderVariantUnsetAsDefaultApiArgSchema,
  PostSalesServiceOrderVariantUnsetAsDefaultApiResponse,
} from './types';

export const businessSalesApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postSalesServiceOrderVariantSetAsActive: build.mutation<
      PostSalesServiceOrderVariantSetAsActiveApiResponse,
      PostSalesServiceOrderVariantSetAsActiveApiArg
    >({
      query: (queryArg) => ({
        url: '/integration/v1/business-case/service-order-variants/activate',
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['serviceOrderVariants'],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostSalesServiceOrderVariantSetAsActiveApiArgSchema,
      },
    }),
    postSalesServiceOrderVariantSetAsInactive: build.mutation<
      PostSalesServiceOrderVariantSetAsInactiveApiResponse,
      PostSalesServiceOrderVariantSetAsInactiveApiArg
    >({
      query: (queryArg) => ({
        url: '/integration/v1/business-case/service-order-variants/deactivate',
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['serviceOrderVariants'],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostSalesServiceOrderVariantSetAsInactiveApiArgSchema,
      },
    }),
    postSalesServiceOrderVariantSetAsDefault: build.mutation<
      PostSalesServiceOrderVariantSetAsDefaultApiResponse,
      PostSalesServiceOrderVariantSetAsDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/integration/v1/business-case/service-order-variants/${queryArg.serviceOrderVariantId}/set-default`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: ['serviceOrderVariants'],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostSalesServiceOrderVariantSetAsDefaultApiArgSchema,
      },
    }),
    postSalesServiceOrderVariantUnsetAsDefault: build.mutation<
      PostSalesServiceOrderVariantUnsetAsDefaultApiResponse,
      PostSalesServiceOrderVariantUnsetAsDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/integration/v1/business-case/service-order-variants/${queryArg.serviceOrderVariantId}/unset-default`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: ['serviceOrderVariants'],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostSalesServiceOrderVariantUnsetAsDefaultApiArgSchema,
      },
    }),
  }),
});

export const {
  usePostSalesServiceOrderVariantSetAsActiveMutation,
  usePostSalesServiceOrderVariantSetAsInactiveMutation,
  usePostSalesServiceOrderVariantSetAsDefaultMutation,
  usePostSalesServiceOrderVariantUnsetAsDefaultMutation,
} = businessSalesApi;
